import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import CreateBusiness from './CreateBusiness';

const BusinessSignupPage: React.FC = () => {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-950 py-12 px-4 sm:px-6 lg:px-8">
            {/* Background decoration */}
            <div className="absolute inset-0 overflow-hidden pointer-events-none">
                <div className="absolute -top-40 -right-40 w-80 h-80 bg-primary-500/10 rounded-full blur-3xl" />
                <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-emerald-500/10 rounded-full blur-3xl" />
            </div>

            <div className="relative max-w-2xl w-full space-y-8">
                {/* Back link */}
                <div className="text-center">
                    <Link 
                        to="/login" 
                        className="inline-flex items-center gap-2 text-gray-400 hover:text-white transition-colors mb-4"
                    >
                        <ArrowLeft className="w-4 h-4" />
                        Volver al inicio
                    </Link>
                </div>

                {/* Logo and Title */}
                <div className="text-center">
                    <div className="flex justify-center mb-6 px-4">
                        <img
                            src="/icons/logo letras.jpg"
                            alt="Reserberry Sport"
                            className="w-full sm:w-[350px] max-w-full h-auto"
                        />
                    </div>
                    <h1 className="text-2xl font-bold text-white mb-2">
                        Registra tu Negocio
                    </h1>
                    <p className="text-gray-400">
                        Crea tu cuenta de administrador y configura tu gimnasio o club deportivo
                    </p>
                </div>

                {/* Form Container */}
                <div className="bg-gray-900 shadow-2xl rounded-2xl overflow-hidden border border-gray-800">
                    <div className="p-8">
                        <CreateBusiness />
                    </div>
                </div>

                {/* Footer */}
                <div className="text-center text-sm text-gray-500">
                    <p>
                        ¿Ya tienes una cuenta?{' '}
                        <Link to="/login" className="text-amber-400 hover:text-amber-300">
                            Inicia sesión
                        </Link>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default BusinessSignupPage;















